import type { ContentHubItem } from "../content-hub/types";
import type { CalendarEvent } from "./types";

/**
 * Map a content-hub item into a calendar event. The `newsquawk-calendar-event`
 * source publishes the full calendar entry as the item payload, so the raw
 * payload IS the calendar event — this just narrows the type and guards against
 * malformed payloads (missing uuid/classification).
 */
export function toCalendarEvent(item: ContentHubItem): CalendarEvent | null {
  const raw = item.raw as Partial<CalendarEvent> | null | undefined;
  if (!raw || typeof raw !== "object") return null;
  if (!raw.uuid || !raw.classification) return null;
  return raw as CalendarEvent;
}
